import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

export function getBoxesList(env, Boxes) {
    return dispatch => {
        return apiCaller
            .call(api.getBoxesList(env, Boxes))
            .then(({ data }) => {
                if (data.success) {
                    if (data.boxes) {
                        dispatch({
                            type: `TESTBENCH__SET_BOX_LIST_FECHED`,
                            boxes: data.boxes
                        });
                    }
                }
                return data.boxes;
            })
            .catch(error => {
                Logger.error(`dataActions: getTestBench${env}BoxesDetails - `, error);
                throw error;
            });
    };
}
export function getBoxDetails(env, boxMac) {
    return dispatch => {
        return apiCaller
            .call(api.getBoxDetails(env, boxMac))
            .then(({ data }) => {
                if (data.box) {
                    dispatch({
                        type: `TESTBENCH__SET_BOX_DETAIL`,
                        boxMac: data.boxMac,
                        box: data.box
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.error(`dataActions: getTestBench${env}BoxDetails - `, error);
                throw error;
            });
    };
}

export function reStartTest(boxMac) {
    return () => {
        return getSocketMiddlewareInstance().testBox(boxMac);
    };
}
export function goProd(env, boxMac, codePack) {
    return dispatch => {
        return apiCaller
            .call(api.setCodePack(env, boxMac, codePack))
            .then(({ data }) => {
                if (data.box) {
                    dispatch({
                        type: `TESTBENCH__SET_BOX_DETAIL`,
                        boxMac: data.boxMac,
                        box: data.box
                    });
                }
                return getSocketMiddlewareInstance().goProd(boxMac);
            })
            .catch(error => {
                Logger.error(`dataActions: getTestBench${env}goProd - `, error);
                throw error;
            });
    };
}
export function loadEnv(env) {
    return () => {
        return getSocketMiddlewareInstance().loadEnv(env);
    };
}



// WEBPACK FOOTER //
// ./environments/testbench/data/Boxes/actions.js